import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';

const ErrorState = ({ message = 'Something went wrong', onRetry }) => {
    return (
        <div className="jk-catalog__error">
            <AlertCircle size={48} className="jk-catalog__error-icon" />
            <h3 className="jk-catalog__error-title">Unable to Load Products</h3>
            <p className="jk-catalog__error-message">{message}</p>
            {onRetry && (
                <button className="jk-btn jk-btn--primary" onClick={onRetry}>
                    <RefreshCw size={18} />
                    <span>Try Again</span>
                </button>
            )}
        </div>
    );
};

export default ErrorState;
